import { Link } from "react-router";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { StackedCell } from "./stacked-cell";

export function formatBookingReference(shortId: number | undefined): string {
  if (shortId == null) return "—";
  return `BK-${shortId.toString().padStart(4, "0")}`;
}

export function bookingViewPath(bookingId: string | undefined): string | undefined {
  const id = bookingId?.trim();
  return id ? `/bookings/${id}` : undefined;
}

export function BookingRefCell({
  bookingRef,
  bookingId,
  shortId,
  secondary,
}: {
  bookingRef?: string;
  bookingId?: string;
  shortId?: number;
  secondary?: ReactNode;
}) {
  const label =
    bookingRef?.trim() ||
    (shortId != null ? formatBookingReference(shortId) : "—");
  const href = bookingViewPath(bookingId);

  const primary =
    href && label !== "—" ? (
      <Link
        to={href}
        className={cn(
          "font-medium text-primary hover:underline underline-offset-2"
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {label}
      </Link>
    ) : (
      <span className="font-medium">{label}</span>
    );

  return <StackedCell primary={primary} secondary={secondary} />;
}
